import { createSelector } from 'reselect';

const selectAuth = (state) => state.auth;

export const selectAccessToken = createSelector(
  [selectAuth],
  (auth) => auth.accessToken
);
